

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import firebase from 'firebase/compat/app';
import Profile from '../components/Profile/Profile.vue';
// import Verify from "../components/Profile/Verify.vue";
import _ from 'lodash';
import successDialog from '../components/successDialog.vue';
import emailjs from 'emailjs-com';

export default {
  data() {
    return {
      submitting: false,
      userType: '',
      borrowerIssue: '',
      //         1. Rental is not returned on time (Supply Side)
      // 2. There is damage to the item (Supply Side & Demand Side)
      // 3. I need a booking extension (Demand Side)
      // 4. The item is not working (Demand Side)
      // 5. Cancel the booking (Supply & Demand side)
      // 6. General Enquiry (Supply & Demand side)
      borrowerIssueTypes: [
        'There is damage to the item',
        'Item is not working',
        'Item was not delivered on time',
        'Other',
      ],
      lenderIssue: '',
      lenderIssueTypes: [
        'There is damage to the item',
        'Rental was not returned on time',
        'Other',
      ],
      ticketText: '',
      uid: '',
      text: '',
      avatarPic: '',
      hasAvatar: true,
      fName: '',
      startDate: null,
      sub: '',
      snackbar: false,
      verified: false,
      supportType: '',
      booking: {},
      // user: {
      //   firstName: 'John',
      //   lastName: 'Doe'
      // }
    };
  },

  components: {
    successDialog,
  },

  mounted() {
    this.userType = this.$route.params.userType;
    this.booking = this.$route.params.booking;
    console.log('data is', this.booking);
    this.supportType = this.$route.params.supportType;
    if (this.supportType === undefined) {
      this.supportType = 'General Enquiry';
    }
    console.log('support type is', this.supportType);
  },

  methods: {
    showToast(msg) {
      console.log('fire toast');
      this.snackbar = true;
      this.text = msg;
    },

    async submitSupportTicket(e) {
      this.submitting = false;
      let ticketType = 'General Enquiry';
      let email = '';
      let name = '';
      let payload = {};

      if (this.booking.status === 'pending-return') {
        this.$store.dispatch('updateBookingData', {
          id: this.booking.id,
          status: 'issue',
        });
      }

      if (this.supportType === 'General Enquiry') {
        ticketType = 'General Enquiry';
        if (this.userType === 'lender') {
          email = this.booking.lenderEmail;
          name = this.booking.lenderName;
        } else {
          email = this.booking.borrowerEmail;
          name = this.booking.borrowerName;
        }
      } else if (this.userType === 'lender') {
        ticketType = this.lenderIssue;
        email = this.booking.lenderEmail;
        name = this.booking.lenderName;
      } else {
        ticketType = this.borrowerIssue;
        email = this.booking.borrowerEmail;
        name = this.booking.borrowerName;
      }
      console.log(ticketType);
      payload = {
        user_name: name,
        ticket_type: ticketType,
        booking_id: this.booking.id,
        ticket_details: this.ticketText,
        user_email: email,
      };
      console.log(payload);
      try {
        emailjs.send(
          'service_crx2ang',
          'template_add65xl',
          payload,
          // e.target,
          'user_EDKMuaufVZ6sQ1QChMQAy'
        );
      } catch (error) {
        console.log({ error });
      }
      this.submitting = true;
    },

    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<template>
  <!-- <v-overlay v-if="submitting">
      <v-img :src="require('@/assets/svgs/gondola2.svg')" />
      Submitting support ticket...
    </v-overlay> -->
  <div class="d-flex justify-center">
    <success-dialog
      style="box-shadow: none !important; overflow: hidden !important"
      v-if="submitting"
    ></success-dialog>
    <v-row style="max-width: 1200px">
      <v-col cols="10" offset="1">
        <v-card color="#F7F7F7" class="pa-3 my-9 px-md-16 py-3 round">
          <v-icon color="#7b1fa2" @click="$router.go(-1)"
            >fas fa-arrow-left</v-icon
          >
          <!-- <v-col cols="1">
            </v-col> -->
          <!-- <v-col cols="11"> -->
          <p class="text-h4 text-center app--text">{{ supportType }}</p>

          <form @submit.prevent="submitSupportTicket">
            <div v-if="supportType === 'Log an Issue'">
              <v-select
                v-if="userType === 'borrower'"
                v-model="borrowerIssue"
                :items="borrowerIssueTypes"
                label="Select an issue type"
                class="round"
                outlined
                color="rgb(34, 34, 34)"
              />

              <v-select
                v-if="userType === 'lender'"
                v-model="lenderIssue"
                :items="lenderIssueTypes"
                label="Select an issue type"
                class="round"
                outlined
                color="rgb(34, 34, 34)"
              />
            </div>
            <div>Please provide some details regarding the support query.</div>
            <v-textarea
              v-model="ticketText"
              placeholder="Start typing..."
              color="rgb(34, 34, 34)"
              type="text"
              required
              solo
              counter
              class="round"
            >
            </v-textarea>
            <div style="display: flex; justify-content: center">
              <v-btn
                elevation="8"
                :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
                color="primary"
                class="ebtn ma-3"
                :disabled="
                  ticketText == '' ||
                  (userType === 'lender' &&
                    supportType === 'Log an Issue' &&
                    lenderIssue === '') ||
                  (userType === 'borrower' &&
                    supportType === 'Log an Issue' &&
                    borrowerIssue === '')
                "
                type="submit"
                >Submit</v-btn
              >
            </div>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </div>
  <!--  -->
</template>

<style scoped>
.center {
  display: grid;
  place-items: center;
}
</style>
